var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6362 15.5745C29.6635 15.5969 30.6967 15.5292 31.72 15.6097C32.7562 15.803 33.006 17.3718 32.0853 17.8856C31.4572 18.224 30.711 18.0116 30.03 18.0713H28.6362V15.5745ZM32.314 12.7485C32.5422 13.5542 31.7656 14.2775 30.9897 14.1666H28.6362C28.6527 13.4068 28.6039 12.5822 28.6601 11.8624C29.6029 11.889 30.5544 11.8083 31.4917 11.9046C31.8945 12.0058 32.2315 12.3369 32.314 12.7485ZM37.9779 0.800837C38.0217 2.33944 37.9842 3.95937 37.9968 5.52918C37.9939 11.9115 38.003 18.2936 37.9918 24.6762C37.9505 27.0681 35.8307 29.1465 33.4553 29.1943C31.0777 29.2039 28.6996 29.1958 26.3216 29.1984V19.5497C28.9126 19.5364 31.5048 19.5769 34.0947 19.5295C35.2962 19.4541 36.6122 18.6613 36.6681 17.3392C36.8095 16.0113 35.5576 15.0929 34.369 14.9478C33.9121 14.9359 33.9255 14.8146 34.369 14.7617C35.5027 14.5167 36.3929 13.3433 36.0594 12.1683C35.7751 10.9324 34.4091 10.454 33.2729 10.4564C30.9562 10.4406 28.639 10.4542 26.3222 10.4496C26.3371 8.64832 26.291 6.84509 26.347 5.04512C26.5306 2.69638 28.7038 0.759429 31.0457 0.801452C33.3568 0.801101 35.6674 0.801101 37.9779 0.801013V0.800837Z",
    fill: "url(#paint0_linear_6816_54623)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.141213 5.28833C0.20038 2.9002 2.32925 0.838854 4.70155 0.803952C7.07042 0.796655 9.43965 0.802897 11.8085 0.800787C11.802 8.79096 11.8214 16.782 11.7988 24.7717C11.7075 27.1309 9.60185 29.1529 7.25539 29.1947C4.88204 29.2033 2.50842 29.1959 0.134971 29.1983V19.2243C2.44037 19.7689 4.85795 20.0008 7.20986 19.6395C8.61571 19.4133 10.1539 18.7229 10.6298 17.2644C10.9801 16.0168 10.7829 14.7038 10.835 13.4233V10.4496H6.76483C6.74654 12.4163 6.80228 14.3865 6.73538 16.3509C6.62566 17.5583 5.42992 18.3254 4.29116 18.2845C2.87889 18.2994 0.0802874 17.261 0.0802874 17.261C0.0732541 13.5761 0.121257 8.96134 0.141213 5.28868V5.28833Z",
    fill: "url(#paint1_linear_6816_54623)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3266 11.649C13.1124 11.6944 13.2836 10.9192 13.2288 10.6251C13.2434 8.76572 13.1983 6.90429 13.2537 5.0462C13.4367 2.68752 15.6266 0.745743 17.978 0.800954H24.9029C24.8964 8.79112 24.9156 16.7822 24.8931 24.7719C24.8018 27.131 22.6959 29.153 20.3494 29.1948C17.976 29.2038 15.6023 29.1962 13.2287 29.1985V18.2707C14.8498 19.6007 17.053 19.8078 19.0726 19.8114C20.5951 19.8109 22.1087 19.5761 23.5872 19.225V17.223C21.921 18.0534 19.9622 18.5809 18.1152 18.1038C16.8267 17.7831 15.8914 16.5379 15.9122 15.2081C15.7629 13.8253 16.5735 12.3654 17.9324 11.9543C19.6196 11.4261 21.4584 11.8301 23.0399 12.5168C23.3787 12.6942 23.7226 12.9143 23.5871 12.3479V10.7743C20.9421 10.145 18.1273 9.91345 15.47 10.598C14.7008 10.815 13.9514 11.1441 13.3266 11.6492V11.649Z",
    fill: "url(#paint2_linear_6816_54623)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6816_54623",
    x1: 26.2419,
    y1: 14.3925,
    x2: 37.9232,
    y2: 14.3925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6816_54623",
    x1: -0.113399,
    y1: 15.2715,
    x2: 11.6171,
    y2: 15.2715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6816_54623",
    x1: 13.2116,
    y1: 14.6677,
    x2: 24.9007,
    y2: 14.6677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbLogo);
export default __webpack_public_path__ + "static/media/JCB-logo.8bbe4406d3861e6b482338d99185a501.svg";
export { ForwardRef as ReactComponent };